<template>
  <v-dialog v-model="$store.state.profileDialogVisible" max-width="500" class="profile-dialog" :retain-focus="false" persistent v-if="$store.state.profileCardData?.full_name">
    <v-card class="py-6 mx-auto bg" rounded="xxl" >
      <v-avatar class="profile avatar-shadow" color="grey" size="164">
        <v-img :src="$store.state.profileCardData.avatar_url || require('@/assets/profile_placeholder.png')"
               alt="require('@/assets/profile_placeholder.png')"></v-img>

      </v-avatar>
      <v-card-title style="text-transform: capitalize">{{ $store.state.profileCardData.full_name }}</v-card-title>
      <v-card-text>
        <div class="text-center">
          <p v-if="$store.state.profileCardData.origin_country">From: {{ $store.state.profileCardData.origin_country }}</p>
          <p v-if="$store.state.profileCardData.current_stay?.tense === 'present' && $store.state.profileCardData.current_stay.departure_date">
            Currently In {{$store.state.profileCardData?.current_stay?.locations.name}}<br> Until {{ formattedDate($store.state.profileCardData.current_stay.departure_date) }}
          </p>
          <p v-else-if="$store.state.profileCardData.current_stay?.tense === 'present'">
            Currently In {{$store.state.profileCardData.current_stay?.locations.name}}
          </p>
        </div>

        <v-divider class="my-3"></v-divider>

        <v-row align="center" class="mx-0">
          <v-col class="text-center" cols="4">
            <v-btn icon :href="$store.state.profileCardData.instagram_account" :disabled="!$store.state.profileCardData.instagram_account">
              <v-icon color="purple" size="24px">mdi-instagram</v-icon>
            </v-btn>
          </v-col>

          <v-col class="text-center" cols="4">
            <v-btn icon :href="adjustedFacebookUrl" :disabled="!$store.state.profileCardData.facebook_account">
              <v-icon color="purple" size="24px">mdi-facebook</v-icon>
            </v-btn>
          </v-col>

          <v-col class="text-center" cols="4">
            <v-btn icon :href="'mailto:' + $store.state.profileCardData.email" :disabled="!$store.state.profileCardData.email">
              <v-icon color="purple" size="24px">mdi-email</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeProfileDialog">
          Close
        </v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  computed: {
    adjustedFacebookUrl() {
      if (/Android/i.test(navigator.userAgent)) {
        return `fb://facewebmodal/f?href=${store.state.profileCardData.facebook_account}`;
      } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        return `fb://profile/${store.state.profileCardData.facebook_account}`;
      } else {
        return store.state.profileCardData.facebook_account;
      }
    },
  },
  methods: {
    formattedDate(dateString) {
      dateString = dateString + 'T12:00:00'
      let date = new Date(dateString);
      date.setDate(date.getDate());
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString(undefined, options);
    },
    closeProfileDialog() {
      store.commit('setProfileCardData', {})
      store.commit('profileDialogOff')
    },
  },
}
</script>

<style scoped>
.upload-btn{
  position: absolute !important;
  z-index: 999;
  top: 121px;
  color: cadetblue;
  background: blueviolet;
  background: rgb(125,198,163);
  background: linear-gradient(50deg, rgba(125,198,163,1) 0%, rgba(35,216,227,1) 72%);
}

.bg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}

.avatar-shadow{
  box-shadow: 0px 0px 10px 0px rgba(50,12,112,0.75);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(50,12,112,0.75);
  -moz-box-shadow: 0px 0px 10px 0px rgba(50,12,112,0.75);
}


</style>
